/* Tollo Health theme scripts */
(function () {
  'use strict';

  /* ---------- Header: scrolled state + dropdowns ---------- */
  function initHeader(root) {
    var header = (root || document).querySelector('[data-header]');
    if (!header) return;
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    var dropdowns = header.querySelectorAll('[data-dropdown]');
    var canHover = window.matchMedia('(hover: hover)').matches;
    dropdowns.forEach(function (d) {
      var item = d.closest('.site-nav__item');
      if (canHover && item) {
        item.addEventListener('mouseenter', function () { d.open = true; });
        item.addEventListener('mouseleave', function () { d.open = false; });
      }
      d.addEventListener('toggle', function () {
        if (d.open) dropdowns.forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
    document.addEventListener('click', function (e) {
      dropdowns.forEach(function (d) { if (!d.contains(e.target)) d.open = false; });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      dropdowns.forEach(function (d) { d.open = false; });
      var mm = header.querySelector('.mobile-menu');
      if (mm && mm.open) { mm.open = false; mm.querySelector('summary').focus(); }
    });
    var mm = header.querySelector('.mobile-menu');
    if (mm) {
      mm.addEventListener('toggle', function () { document.body.style.overflow = mm.open ? 'hidden' : ''; });
      var closeBtn = mm.querySelector('[data-close-menu]');
      if (closeBtn) closeBtn.addEventListener('click', function () { mm.open = false; });
    }
  }

  /* ---------- Hero slider ---------- */
  function initSlider(el) {
    if (!el || el.dataset.ready) return;
    el.dataset.ready = '1';
    var slides = el.querySelectorAll('[data-slide]');
    var tabs = el.querySelectorAll('[data-goto]');
    if (slides.length < 2) return;
    var i = 0, timer = null;
    var autoplay = el.dataset.autoplay === 'true';
    var speed = parseInt(el.dataset.speed, 10) || 7000;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    el.style.setProperty('--speed', speed + 'ms');

    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        var on = k === i;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
        s.querySelectorAll('a, button').forEach(function (a) { a.tabIndex = on ? 0 : -1; });
      });
      el.classList.toggle('is-overlay', slides[i].classList.contains('hero-slide--overlay'));
      tabs.forEach(function (t, k) {
        t.setAttribute('aria-current', k === i ? 'true' : 'false');
      });
      restart();
    }
    function restart() {
      clearTimeout(timer);
      if (autoplay && !reduce && !el.classList.contains('is-paused')) timer = setTimeout(function () { go(i + 1); }, speed);
    }
    var prev = el.querySelector('[data-prev]'), next = el.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function () { go(i - 1); });
    if (next) next.addEventListener('click', function () { go(i + 1); });
    tabs.forEach(function (t) { t.addEventListener('click', function () { go(parseInt(t.dataset.goto, 10)); }); });
    el.addEventListener('mouseenter', function () { el.classList.add('is-paused'); clearTimeout(timer); });
    el.addEventListener('mouseleave', function () { el.classList.remove('is-paused'); restart(); });
    el.addEventListener('focusin', function () { el.classList.add('is-paused'); clearTimeout(timer); });
    el.addEventListener('focusout', function () { el.classList.remove('is-paused'); restart(); });
    el._go = go;
    go(0);
  }

  /* ---------- Product: gallery + variants + quantity ---------- */
  function initProduct(root) {
    (root || document).querySelectorAll('[data-product]').forEach(function (p) {
      var main = p.querySelector('[data-main-media]');
      p.querySelectorAll('[data-thumb]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (!main) return;
          main.innerHTML = btn.dataset.full;
          p.querySelectorAll('[data-thumb]').forEach(function (b) { b.setAttribute('aria-current', b === btn ? 'true' : 'false'); });
        });
      });
      var select = p.querySelector('[data-variant-select]');
      var json = p.querySelector('[data-product-json]');
      if (select && json) {
        var variants = JSON.parse(json.textContent);
        var priceEl = p.querySelector('[data-price]');
        var btn = p.querySelector('[data-add]');
        select.addEventListener('change', function () {
          var v = variants.find(function (x) { return String(x.id) === select.value; });
          if (!v) return;
          if (priceEl) priceEl.innerHTML = v.price_html;
          if (btn) { btn.disabled = !v.available; btn.textContent = v.available ? btn.dataset.addLabel : btn.dataset.soldLabel; }
          if (v.image && main) main.innerHTML = v.image;
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        });
      }
    });
    document.querySelectorAll('[data-qty]').forEach(function (q) {
      if (q.dataset.ready) return; q.dataset.ready = '1';
      var input = q.querySelector('input');
      q.querySelectorAll('[data-step]').forEach(function (b) {
        b.addEventListener('click', function () {
          var min = parseInt(input.min || '0', 10);
          input.value = Math.max(min, (parseInt(input.value, 10) || 0) + parseInt(b.dataset.step, 10));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ---------- Collection sort ---------- */
  function initSort() {
    document.querySelectorAll('[data-sort]').forEach(function (s) {
      s.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', s.value);
        window.location = url.toString();
      });
    });
  }

  function initAll(root) {
    initHeader(root);
    (root || document).querySelectorAll('[data-slider]').forEach(initSlider);
    initProduct(root);
    initSort();
  }

  document.addEventListener('DOMContentLoaded', function () { initAll(document); });

  /* ---------- Theme editor support ---------- */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var slider = e.target.closest('[data-slider]');
    if (!slider || !slider._go) return;
    var slides = Array.prototype.slice.call(slider.querySelectorAll('[data-slide]'));
    var idx = slides.indexOf(e.target);
    if (idx > -1) { slider.classList.add('is-paused'); slider._go(idx); }
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var slider = e.target.closest('[data-slider]');
    if (slider) slider.classList.remove('is-paused');
  });
})();
